'use strict'

// Utilities
import { defaultObj } from './state'
import isEmpty from '../../utility/isEmpty'

export default {
  setPredictions (state, predictions) {
    if (!isEmpty(predictions)) {
      state.predictions = predictions
    }
  },

  clearPredictions (state) {
    state.predictions = []
  },

  clearPlaceDetails (state) {
    state.placeDetails = {}
  },

  setPlaceDetails (state, placeDetails) {
    if (!isEmpty(placeDetails)) {
      state.placeDetails = placeDetails
    }
  },

  setAllStateOptions (state, allStates) {
    if (!isEmpty(allStates)) {
      state.addressStateOptions = allStates.map(obj => ({ value: obj.Abbreviation, text: obj.Abbreviation }))
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
